<template>
    <div class="view">
        <div class="uoloadImgBox">
            <van-uploader :after-read="(file) => afterRead(file, 1)">
                <van-image class="img" :src="driverInfo.idcard_front || defaultImg1" radius="5">
                        <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                </van-image>
            </van-uploader>
            <van-uploader :after-read="(file) => afterRead(file, 2)">
                <van-image class="img" :src="driverInfo.idcard_back || defaultImg2" radius="5">
                        <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                </van-image>
            </van-uploader>
            <van-uploader :after-read="(file) => afterRead(file, 3)">
                <van-image class="img" :src="driverInfo.driver_front || defaultImg3" radius="5">
                        <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                </van-image>
            </van-uploader>
            <van-uploader :after-read="(file) => afterRead(file, 4)">
                <van-image class="img" :src="driverInfo.driver_back || defaultImg4" radius="5">
                        <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                </van-image>
            </van-uploader>
        </div>
        <div class="infoBox">
            <div class="infoLi">
                <div class="label">手机号</div>
                <div class="value">{{ driverInfo.mobile }}</div>
            </div>
            <div class="infoLi">
                <div class="label">真实姓名</div>
                <div :class="['value', {'placeholder': !driverInfo.name}]">{{ driverInfo.name || '上传身份证人像面识别' }}</div>
            </div>
            <div class="infoLi">
                <div class="label">身份证号码</div>
                <div :class="['value', {'placeholder': !driverInfo.number}]">{{ driverInfo.number || '上传身份证人像面识别' }}</div>
            </div>
            <div class="infoLi">
                <div class="label">身份证地址</div>
                <div :class="['value', {'placeholder': !driverInfo.address}]">{{ driverInfo.address || '上传身份证人像面识别' }}</div>
            </div>
            <div class="infoLi">
                <div class="label">身份证有效期</div>
                <div :class="['value', {'placeholder': !driverInfo.valid_to}]">{{ driverInfo.valid_to || '上传身份证国徽面识别' }}</div>
            </div>
            <div class="infoLi">
                <div class="label">驾驶证号码</div>
                <div :class="['value', {'placeholder': !driverInfo.driver_number}]">{{ driverInfo.driver_number || '上传驾驶证识别' }}</div>
            </div>
            <div class="infoLi">
                <div class="label">准驾车型</div>
                <div :class="['value', {'placeholder': !driverInfo.driver_class}]">{{ driverInfo.driver_class || '上传驾驶证识别' }}</div>
            </div>
            <div class="infoLi">
                <div class="label">驾驶证有效期</div>
                <div :class="['value', {'placeholder': !driverInfo.driver_valid_to}]">{{ driverInfo.driver_valid_to || '上传驾驶证识别' }}</div>
            </div>
        </div>
        <div class="footer">
            <div class="btn" @click="submitAuth">提交认证</div>
        </div>
        <!-- 上传头像认证 -->
        <van-popup 
            v-model="uploadAvatarShow" 
            class="uploadAvatarBox"
            closeable>
            <div class="uploadTitle">{{ driverInfo.avatar ? '系统认证中' : '上传头像' }}</div>
            <div class="uploadTips">
                <p>请使用前置相机拍摄，需与身份信息一致</p>
            </div>
            <div class="uploadBtn">
                <van-uploader 
                    upload-text="点击上传头像"
                    capture="camera"
                    :after-read="affirm"
                    max-count='1' />
            </div>
        </van-popup>
    </div>
</template>

<script>
import Compressor from 'compressorjs';
import { driverDetail, ocrIdcard, ocrDriver, driverIdentity } from '@/apis/join'
export default {
    data(){
        return {
            driverId: '',
            defaultImg1: 'https://h5.zykjsz.com/images/merchantApp/nocr1.png',
            defaultImg2: 'https://h5.zykjsz.com/images/merchantApp/nocr2.png',
            defaultImg3: 'https://h5.zykjsz.com/images/merchantApp/nocr3.png',
            defaultImg4: 'https://h5.zykjsz.com/images/merchantApp/nocr4.png',
            uploadAvatarShow: false,
            //师傅详情
            driverInfo: {
                avatar: '',         //头像链接
                idcard_front: '',
                idcard_back: '',
                driver_front: '',
                driver_back: '',
                mobile: '',
                name: '',
                number: '',
                address: '',
                valid_to: '',
                valid_from: '',
                driver_number: '',
                driver_valid_to: '',
                driver_valid_from: '',
                driver_class: '',
                driver_key1: '',        //驾驶证正本key
                driver_key2: '',        //驾驶证副本key
            },
        }
    },
    mounted(){
        let e = this.$route.query.e
        if(e){
            let info = this.$xorEncrypt(e)
            info = JSON.parse(info)
            let nowTime = new Date().getTime();
            if(nowTime - info.time > 12*60*60*1000){
                this.toRegister(info.company)
            }else{
                this.driverId = info.id
                this.getDetail()
            }
        }else{
            this.toRegister()
        }
    },
    methods: {
        // 回注册页
        toRegister(s){
            this.$notify({
                type: 'danger',
                message: '验证信息过期，请重新获取验证码！'
            })
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('driverId');
            this.$router.replace(`/register?s=${s}`);
        },
        // 师傅详情
        getDetail(){
            let params = {
                id: this.driverId
            }
            driverDetail(params).then((res)=>{
                console.log(res, '师傅详情')
                let info = res.data.data
                this.driverInfo.idcard_front = info.idcard_front
                this.driverInfo.idcard_back = info.idcard_back
                this.driverInfo.driver_front = info.driver_front
                this.driverInfo.driver_back = info.driver_back
                this.driverInfo.name = info.name
                this.driverInfo.mobile = info.mobile
                this.driverInfo.number = info.number
                this.driverInfo.address = info.address
                this.driverInfo.valid_to = info.valid_to && info.valid_to != '0000-00-00' ? info.valid_to : ''
                this.driverInfo.driver_number = info.driver_number
                this.driverInfo.driver_valid_to = info.driver_valid_to && info.driver_valid_to != '0000-00-00' ? info.driver_valid_to : ''
            })
        },
        submitAuth(){
            console.log(this.driverInfo)
            let info = this.driverInfo
            if(!info.idcard_front || !info.name || !info.number || !info.address){
                this.$notify({ 
                    type: 'danger',
                    message: '请重新上传身份证人像面照片！'
                });
                return
            }
            if(!info.idcard_back || !info.valid_to){
                this.$notify({ 
                    type: 'danger',
                    message: '请重新上传身份证国徽面照片！'
                });
                return
            }
            if(!info.driver_front || !info.driver_key1){
                this.$notify({ 
                    type: 'danger',
                    message: '请重新上传驾驶证主页照片！'
                });
                return
            }
            if(!info.driver_back || !info.driver_key2){
                this.$notify({ 
                    type: 'danger',
                    message: '请重新上传驾驶证副页照片！'
                });
                return
            }
            this.driverInfo.avatar = ''
            this.uploadAvatarShow = true
        },
        afterRead(file, t){
            let that = this
            new Compressor(file.file, {
                quality: 0.2,
                success(result) {
                    console.log(result, 'result')
                    // t 1: 身份证人像，2身份证国徽  3驾驶证  4驾驶证反面
                    that.$toast.loading({
                        message: '自动识别中...',
                        forbidClick: true,
                        overlay: true,
                        duration: 0,
                        loadingType: 'spinner',
                    });
                    let formData = new FormData();
                    formData.append('file', result)
                    if(t == 1 || t == 2){
                        ocrIdcard(formData).then((res)=>{
                            let data = res.data
                            that.$notify({
                                type: data.code == 1 ? 'success' : 'danger',
                                message: data.code == 1 ? '识别成功' : data.info
                            })
                            if(data.code == 1){
                                let info = data.data
                                if(t == 1){
                                    that.driverInfo.idcard_front = info.url
                                    that.driverInfo.name = info.data.name
                                    that.driverInfo.number = info.data.number
                                    that.driverInfo.address = info.data.address
                                }else if(t == 2){
                                    that.driverInfo.idcard_back = info.url
                                    that.driverInfo.valid_to = info.data.valid_to
                                    that.driverInfo.valid_from = info.data.valid_from
                                }
                            }
                            that.$toast.clear();
                        }).catch((err)=>{
                            that.$toast.clear();
                        })
                    }else if(t == 3 || t == 4){
                        ocrDriver(formData).then((res)=>{
                            console.log('驾驶证识别', res)
                            let data = res.data
                            that.$notify({
                                type: data.code == 1 ? 'success' : 'danger',
                                message: data.code == 1 ? '识别成功' : data.info
                            })
                            if(data.code == 1){
                                let info = data.data
                                if(t == 3){
                                    that.driverInfo.driver_front = info.url
                                    that.driverInfo.driver_key1 = info.key
                                    that.driverInfo.driver_number = info.data.number
                                    that.driverInfo.driver_class = info.data.class
                                    that.driverInfo.driver_valid_to = info.data.valid_to
                                    that.driverInfo.driver_valid_from = info.data.valid_from
                                }else if(t == 4){
                                    that.driverInfo.driver_back = info.url
                                    that.driverInfo.driver_key2 = info.key
                                }
                            }
                            that.$toast.clear();
                        }).catch((err)=>{
                            that.$toast.clear();
                        })
                    }
                }
            })
        },
        // 提交实名认证
        affirm(file){
            let that = this
            new Compressor(file.file, {
                quality: 0.2,
                success(result) {
                    that.$toast.loading({
                        message: '系统认证中...',
                        forbidClick: true,
                        overlay: true,
                        duration: 0,
                        loadingType: 'spinner',
                    });
                    let info = that.driverInfo
                    let formData = new FormData();
                    formData.append('file', result)
                    formData.append('mobile', info.mobile)
                    formData.append('name', info.name)
                    formData.append('number', info.number)
                    formData.append('address', info.address)
                    formData.append('idcard_front', info.idcard_front)
                    formData.append('idcard_back', info.idcard_back)
                    formData.append('valid_from', info.valid_from)
                    formData.append('valid_to', info.valid_to)
                    formData.append('driver_front', info.driver_front)
                    formData.append('driver_back', info.driver_back)
                    formData.append('driver_key1', info.driver_key1)
                    formData.append('driver_key2', info.driver_key2)
                    driverIdentity(formData).then((res)=>{
                        console.log('实名认证', res)
                        let data = res.data
                        if(data.code == 4000){
                            that.uploadAvatarShow = false
                            that.$toast.clear();
                            that.$notify({
                                type: 'danger',
                                message: '登录异常，请重新获取验证码登录！'
                            })
                            this.$router.go(-1)
                            return
                        }
                        that.$notify({
                            type: data.code == 1 ? 'success' : 'danger',
                            message: data.code == 1 ? '认证成功' : data.info
                        })
                        if(data.code == 1){
                            that.$router.go(-1)
                        }
                        that.uploadAvatarShow = false
                        that.$toast.clear();
                    }).catch((err)=>{
                        that.uploadAvatarShow = false
                        that.$toast.clear();
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss">
    .uploadAvatarBox{
        .van-uploader__preview, .van-uploader__upload {
            width: 180px;
            height: 180px;
            .van-image{
                width: 180px;
                height: 180px;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .view{
        min-height: 100vh;
        font-size: 14px;
        color: #333333;
        background: #F7F7F7;
        padding-bottom: 60px;
        box-sizing: border-box;
        .uoloadImgBox{
            width: 100%;
            background: #FFFFFF;
            padding: 12px 12px 0;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-bottom: 12px;
            .img{
                width: 170px;
                height: 109px;
                margin-bottom: 12px;
                background: #e4e4e4;
            }
        }
        .infoBox{
            background: #FFFFFF;
            padding: 0 12px;
            box-sizing: border-box;
            .infoLi{
                height: 40px;
                display: flex;
                align-items: center;
                .label{
                    width: 112px;
                    color: #666;
                }
                .value{
                    flex: 1;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .placeholder{
                    color: #999;
                }
            }
        }
        .footer{
            width: 375px;
            background: #FFFFFF;
            padding: 6px 12px;
            box-sizing: border-box;
            position: fixed;
            bottom: 0;
            .btn{
                width: 100%;
                height: 40px;
                background: var(--theme-color);
                border-radius: 20px;
                font-weight: 600;
                font-size: 16px;
                color: var(--theme-btn);
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .uploadAvatarBox{
            width: 270px;
            border-radius: 6px;
            .uploadTitle{
                height: 50px;
                text-align: center;
                line-height: 50px;
                font-weight: bold;
                font-size: 16px;
            }
            .uploadTips{
                text-align: center;
                color: red;
                font-size: 13px;
            }
            .uploadBtn{
                padding: 20px;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
            }
        }
    }
</style>